module.exports = __webpack_public_path__ + "static/img/back.7bd1607.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/empty/back.png
// module id = Q9YM
// module chunks = 180